import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=9a53b03e&"
import script from "./Notes.vue?vue&type=script&lang=js&"
export * from "./Notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a53b03e')) {
      api.createRecord('9a53b03e', component.options)
    } else {
      api.reload('9a53b03e', component.options)
    }
    module.hot.accept("./Notes.vue?vue&type=template&id=9a53b03e&", function () {
      api.rerender('9a53b03e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/Notes.vue"
export default component.exports